module.exports = __webpack_public_path__ + "static/img/11.b1837f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/11.png
// module id = V+WC
// module chunks = 0